@if (type(); as type) {
@if (type === 'eudiw') {
<button type="button" hisImage="WALLET" class="transparent"
        [title]="'cs.sys.filemanagement.DocumentMetadataProperty.dataSource.type.eudiw' | hisUi"
        (click)="panel.toggle($event)"></button>
<p-overlayPanel #panel [showCloseIcon]="true" [dismissable]="true">
    <ng-template pTemplate>
        <div class="dataSource" [style.--wallet-image]="walletBackground()">
            <his-safe-html [html]="contentDescription()" />
        </div>
    </ng-template>
</p-overlayPanel>
}
}